// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"6f1b51db","126":"897c454b","177":"37b8e4e7","326":"e5ea1b69","579":"6bf14b95","623":"897c454b","719":"fbb27d09","838":"82f8e800","925":"0f19dbdc"}[chunkId] + ".chunk.css";
};